/*
  Warranty claim wizard (front-end draft).
  Steps: 1 source -> 2 verify (online OR store) -> 3 issue -> 4 shipping -> 5 review -> done.
  Submission is a demo success for now; backend validation + order creation is the next phase.
*/
(function () {
  function init() {
    var root = document.querySelector('[data-warranty]');
    if (!root) return;

    var form = root.querySelector('[data-wty-form]');
    var bar = root.querySelector('[data-wty-bar]');
    var backBtn = root.querySelector('[data-wty-back]');
    var nextBtn = root.querySelector('[data-wty-next]');
    var submitBtn = root.querySelector('[data-wty-submit]');
    var done = root.querySelector('[data-wty-done]');
    var nav = root.querySelector('[data-wty-nav]');
    var review = root.querySelector('[data-wty-review]');
    var errEl = root.querySelector('[data-wty-error]');
    var backendUrl = (root.getAttribute('data-backend-url') || '').trim();
    var cloudName = (root.getAttribute('data-cloud-name') || '').trim();
    var uploadPreset = (root.getAttribute('data-upload-preset') || '').trim();

    var TOTAL = 5;
    var step = 1;
    var source = null; // 'online' | 'store'

    // Required fields per step (by input name)
    var REQ = {
      '2online': ['order_number', 'order_identity'],
      '2store': ['store', 'purchase_date'],
      '2amazon': ['amazon_order', 'amazon_date'],
      '3': ['device_id', 'item', 'issue'],
      '4': ['ship_name', 'ship_email', 'ship_phone', 'ship_addr1', 'ship_city', 'ship_state', 'ship_zip'],
      '5': ['confirm']
    };

    var LABELS = {
      order_number: 'Order number', order_identity: 'Name / email', store: 'Store',
      amazon_order: 'Amazon order number', amazon_date: 'Date of purchase',
      purchase_date: 'Date of purchase', device_id: 'Bag ID', item: 'Item', issue: 'Issue',
      ship_name: 'Ship to', ship_phone: 'Phone', ship_email: 'Email',
      ship_addr1: 'Address', ship_city: 'City', ship_state: 'State', ship_zip: 'ZIP'
    };

    function stepEl(n) {
      if (n === 2) return root.querySelector('.wty__step[data-step="2"][data-when="' + source + '"]');
      return root.querySelector('.wty__step[data-step="' + n + '"]:not([data-when])');
    }

    function show(n) {
      root.querySelectorAll('.wty__step').forEach(function (s) { s.classList.remove('is-active'); });
      var el = stepEl(n);
      if (el) el.classList.add('is-active');
      bar.style.width = Math.round((n / TOTAL) * 100) + '%';
      backBtn.hidden = n === 1;
      nextBtn.hidden = (n === 1 || n === TOTAL);
      submitBtn.hidden = n !== TOTAL;
      if (n === TOTAL) buildReview();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function reqKey(n) {
      if (n === 2) return '2' + source;
      return '' + n;
    }

    function validate(n) {
      var names = REQ[reqKey(n)] || [];
      var ok = true, firstBad = null;
      names.forEach(function (name) {
        var field = form.querySelector('[name="' + name + '"]');
        if (!field) return;
        var val = field.type === 'checkbox' ? field.checked : (field.value || '').trim();
        var bad = !val;
        var wrap = field.closest('.wty__field') || field.parentNode;
        if (wrap.classList) wrap.classList.toggle('is-invalid', bad);
        if (bad && !firstBad) firstBad = field;
        if (bad) ok = false;
      });
      if (firstBad) firstBad.focus();
      return ok;
    }

    // Step 1 choices
    root.querySelectorAll('.wty__choice').forEach(function (c) {
      c.addEventListener('click', function () {
        source = c.getAttribute('data-source');
        root.querySelectorAll('.wty__choice').forEach(function (x) { x.classList.toggle('is-selected', x === c); });
        step = 2;
        show(step);
      });
    });

    function setErr(msg) { if (errEl) { errEl.textContent = msg || ''; errEl.hidden = !msg; } }

    // Verify order # + email against the backend before allowing the customer to proceed.
    function verifyOrder() {
      setErr('');
      var order = val('order_number'), identity = val('order_identity');
      nextBtn.disabled = true; nextBtn.textContent = 'Checking…';
      var url = backendUrl + '?action=verify&order=' + encodeURIComponent(order) + '&identity=' + encodeURIComponent(identity);
      fetch(url).then(function (r) { return r.json(); }).then(function (res) {
        nextBtn.disabled = false; nextBtn.textContent = 'Continue';
        if (res && res.ok) { step++; show(step); }
        else if (res && res.expired) { setErr('This order is outside the 6-month warranty window — it’s no longer covered. Contact info@nyangear.com if you think this is a mistake.'); }
        else { setErr('That order number and email don’t match. Double-check and try again.'); }
      }).catch(function () {
        nextBtn.disabled = false; nextBtn.textContent = 'Continue';
        setErr('We couldn’t verify that just now — please try again.');
      });
    }

    nextBtn.addEventListener('click', function () {
      if (!validate(step)) return;
      if (step === 3 && !hasMedia()) { setMediaErr(true); if (mediaField) mediaField.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (step === 3 && isCrash() && !hasCrashProof()) { setCrashErr(true); if (crashField) crashField.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (step === 2 && source === 'online' && backendUrl) { verifyOrder(); return; }
      if (step < TOTAL) { step++; show(step); }
    });
    backBtn.addEventListener('click', function () {
      setErr('');
      if (step > 1) { step--; show(step); }
    });

    // Store combo box (drops straight down) fed by the dealer list (same source as the map)
    (function buildStoreCombo() {
      var wrap = root.querySelector('[data-wty-combo]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-wty-combo-input]');
      var list = wrap.querySelector('[data-wty-combo-list]');
      var stores = [];
      var el = document.getElementById('nyan-dealer-data');
      try {
        var seen = {};
        JSON.parse(el.textContent).forEach(function (d) { if (d.name && !seen[d.name]) { seen[d.name] = 1; stores.push(d.name); } });
      } catch (e) {}
      stores.sort();

      function render() {
        var q = input.value.trim().toLowerCase();
        var matches = stores.filter(function (s) { return !q || s.toLowerCase().indexOf(q) !== -1; }).slice(0, 40);
        if (!matches.length) { list.hidden = true; return; }
        list.innerHTML = matches.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('');
        list.hidden = false;
      }
      input.addEventListener('focus', render);
      input.addEventListener('input', render);
      list.addEventListener('click', function (e) {
        var li = e.target.closest('li');
        if (li) { input.value = li.textContent; list.hidden = true; }
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) list.hidden = true; });
    })();

    // File previews
    var fileInput = root.querySelector('#wty-files');
    var previews = root.querySelector('[data-wty-previews]');
    var mediaField = root.querySelector('[data-wty-media-field]');
    var mediaError = root.querySelector('[data-wty-media-error]');
    function hasMedia() { return !!(fileInput && fileInput.files && fileInput.files.length); }
    function setMediaErr(bad) {
      if (mediaField) mediaField.classList.toggle('is-invalid', bad);
      if (mediaError) mediaError.hidden = !bad;
    }
    if (fileInput && previews) {
      fileInput.addEventListener('change', function () {
        setMediaErr(false);
        previews.innerHTML = '';
        Array.prototype.slice.call(fileInput.files).forEach(function (f) {
          var fig = document.createElement('figure');
          if (f.type.indexOf('video') === 0) {
            fig.innerHTML = '<span class="wty__file-vid">🎬</span>';
          } else {
            var img = document.createElement('img');
            img.src = URL.createObjectURL(f);
            fig.appendChild(img);
          }
          previews.appendChild(fig);
        });
      });
    }

    // Claim type (Technical / Crash) + crash-proof upload (police report or video).
    var claimTypeSel = root.querySelector('[data-wty-claim-type]');
    var crashField = root.querySelector('[data-wty-crash-field]');
    var crashInput = root.querySelector('#wty-crash-proof');
    var crashPreviews = root.querySelector('[data-wty-crash-previews]');
    var crashError = root.querySelector('[data-wty-crash-error]');
    function isCrash() { return !!(claimTypeSel && claimTypeSel.value === 'crash'); }
    function hasCrashProof() { return !!(crashInput && crashInput.files && crashInput.files.length); }
    function setCrashErr(bad) {
      if (crashField) crashField.classList.toggle('is-invalid', bad);
      if (crashError) crashError.hidden = !bad;
    }
    if (claimTypeSel && crashField) {
      var syncCrash = function () { var on = isCrash(); crashField.hidden = !on; crashField.style.display = on ? '' : 'none'; if (!on) setCrashErr(false); };
      claimTypeSel.addEventListener('change', syncCrash);
      syncCrash();
    }
    if (crashInput && crashPreviews) {
      crashInput.addEventListener('change', function () {
        setCrashErr(false);
        crashPreviews.innerHTML = '';
        Array.prototype.slice.call(crashInput.files).forEach(function (f) {
          var fig = document.createElement('figure');
          if (f.type.indexOf('video') === 0) { fig.innerHTML = '<span class="wty__file-vid">🎬</span>'; }
          else if ((f.type || '').indexOf('pdf') !== -1) { fig.innerHTML = '<span class="wty__file-vid">📄</span>'; }
          else { var img = document.createElement('img'); img.src = URL.createObjectURL(f); fig.appendChild(img); }
          crashPreviews.appendChild(fig);
        });
      });
    }

    function val(name) { var f = form.querySelector('[name="' + name + '"]'); return f ? (f.value || '').trim() : ''; }

    function buildReview() {
      var rows = [];
      rows.push(['Bought from', source === 'online' ? 'Nyangear.com' : (source === 'amazon' ? 'Amazon' : 'Retail store')]);
      if (source === 'online') {
        rows.push(['Order', val('order_number')]);
        rows.push(['Verified by', val('order_identity')]);
      } else if (source === 'amazon') {
        rows.push(['Amazon order', val('amazon_order')]);
        rows.push(['Purchased', val('amazon_date')]);
        rows.push(['Bag ID', val('device_id')]);
      } else {
        rows.push(['Store', val('store')]);
        rows.push(['Purchased', val('purchase_date')]);
        rows.push(['Bag ID', val('device_id')]);
      }
      rows.push(['Item', val('item')]);
      rows.push(['Damage type', isCrash() ? 'Crash' : 'Technical failure']);
      rows.push(['Issue', val('issue')]);
      var nFiles = fileInput && fileInput.files ? fileInput.files.length : 0;
      rows.push(['Photos/video', nFiles ? (nFiles + ' attached') : 'None']);
      if (isCrash()) { var nc = crashInput && crashInput.files ? crashInput.files.length : 0; rows.push(['Police report / video', nc ? (nc + ' attached') : 'None']); }
      rows.push(['Ship to', [val('ship_name'), val('ship_addr1'), val('ship_city') + ', ' + val('ship_state') + ' ' + val('ship_zip')].filter(Boolean).join(' · ')]);
      review.innerHTML = rows.map(function (r) {
        return '<div class="wty__review-row"><span>' + r[0] + '</span><span>' + (r[1] ? esc(r[1]) : '—') + '</span></div>';
      }).join('');
    }

    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function showDone() {
      root.querySelectorAll('.wty__step').forEach(function (s) { s.classList.remove('is-active'); });
      nav.hidden = true; bar.style.width = '100%';
      done.hidden = false; done.setAttribute('data-shown', '1');
      done.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function buildClaim() {
      return { action: 'submit', source: source,
        claim_type: isCrash() ? 'crash' : 'technical',
        order: val('order_number'), identity: val('order_identity'),
        store: val('store'), amazon_order: val('amazon_order'),
        purchase_date: source === 'amazon' ? val('amazon_date') : val('purchase_date'), device_id: val('device_id'),
        item: val('item'), issue: val('issue'),
        ship: { name: val('ship_name'), phone: val('ship_phone'), email: val('ship_email'),
                addr1: val('ship_addr1'), addr2: val('ship_addr2'), city: val('ship_city'), state: val('ship_state'), zip: val('ship_zip') } };
    }
    var submitErr = root.querySelector('[data-wty-submit-error]');
    function setSubmitErr(m) { if (submitErr) { submitErr.textContent = m || ''; submitErr.hidden = !m; } }

    // Upload each selected photo/video straight to Cloudinary; returns the hosted URLs.
    function uploadInput(input) {
      var files = (input && input.files) ? Array.prototype.slice.call(input.files) : [];
      if (!files.length || !cloudName || !uploadPreset) return Promise.resolve([]);
      var endpoint = 'https://api.cloudinary.com/v1_1/' + cloudName + '/auto/upload';
      return Promise.all(files.map(function (f) {
        var fd = new FormData();
        fd.append('file', f);
        fd.append('upload_preset', uploadPreset);
        return fetch(endpoint, { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) { return res.secure_url || null; })
          .catch(function () { return null; });
      })).then(function (urls) { return urls.filter(Boolean); });
    }
    function uploadMedia() { return uploadInput(fileInput); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(TOTAL)) return;
      setSubmitErr('');
      if (!hasMedia()) { setSubmitErr('Please add at least one photo or video of the issue before submitting.'); return; }
      if (isCrash() && !hasCrashProof()) { setSubmitErr('Crash claims require a police report or a video of the crash.'); return; }
      if (!backendUrl) { showDone(); return; }
      submitBtn.disabled = true;
      var hasFiles = (fileInput && fileInput.files && fileInput.files.length) || hasCrashProof();
      submitBtn.textContent = hasFiles ? 'Uploading…' : 'Submitting…';
      Promise.all([uploadMedia(), hasCrashProof() ? uploadInput(crashInput) : Promise.resolve([])]).then(function (uploaded) {
        submitBtn.textContent = 'Submitting…';
        var claim = buildClaim();
        claim.media = uploaded[0];
        if (uploaded[1] && uploaded[1].length) claim.crash_proof = uploaded[1].join(' ');
        return fetch(backendUrl, { method: 'POST', body: JSON.stringify(claim) }).then(function (r) { return r.json(); });
      }).then(function (res) {
        submitBtn.disabled = false; submitBtn.textContent = 'Submit claim';
        if (res && res.ok) showDone();
        else setSubmitErr((res && res.message) || 'Something went wrong — please try again.');
      }).catch(function () {
        submitBtn.disabled = false; submitBtn.textContent = 'Submit claim';
        setSubmitErr('Couldn’t submit — please try again.');
      });
    });

    show(1);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();